var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _circle, _path, _path2, _circle2, _path3, _polygon16, _rect, _polygon17, _path4, _path5, _path6, _path7, _path8, _path9, _circle3, _path10, _path11, _path12, _path13, _path14, _ellipse, _ellipse2, _rect2, _rect3, _path15, _circle4, _rect4, _path16, _circle5, _rect5, _path17, _circle6, _rect6, _path18, _circle7, _rect7, _path19, _circle8, _rect8, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 870.66064,
    height: 688.95313,
    viewBox: "0 0 870.66064 688.95313",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "among_nature") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "80.859 603 71.359 674 90.359 674 80.859 603",
    fill: "#3f3d56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "70.859 609 61.359 680 80.359 680 70.859 609",
    fill: "#3f3d56"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "58.859 609 49.359 680 68.359 680 58.859 609",
    fill: "#3f3d56"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "652.859 581 643.359 652 662.359 652 652.859 581",
    fill: "#3f3d56"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "665.859 581 656.359 652 675.359 652 665.859 581",
    fill: "#3f3d56"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "675.859 596 666.359 667 685.359 667 675.859 596",
    fill: "#3f3d56"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "688.859 596 679.359 667 698.359 667 688.859 596",
    fill: "#3f3d56"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "744.859 607 735.359 678 754.359 678 744.859 607",
    fill: "#3f3d56"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "757.859 607 748.359 678 767.359 678 757.859 607",
    fill: "#3f3d56"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "775.889 682 759.829 682 760.369 678 763.749 652.74 763.859 651.87 767.859 622 772.239 654.75 774.359 670.58 775.889 682",
    fill: "#3f3d56"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "788.889 682 772.829 682 774.359 670.58 776.349 655.74 780.859 622 785.679 658.04 785.679 658.05 787.089 668.58 788.889 682",
    fill: "#3f3d56"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "802.419 682 785.299 682 787.089 668.58 788.409 658.73 793.859 618 799.699 661.62 800.359 666.58 802.419 682",
    fill: "#3f3d56"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "815.419 682 798.299 682 800.359 666.58 800.979 661.95 806.859 618 812.859 662.87 813.179 665.21 815.419 682",
    fill: "#3f3d56"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "823.419 682 810.299 682 812.569 665.05 812.859 662.87 816.859 633 821.469 667.49 823.359 681.58 823.419 682",
    fill: "#3f3d56"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "836.419 682 823.299 682 823.359 681.58 825.109 668.5 829.859 633 834.989 671.31 836.419 682",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 95.85889,
    cy: 95.5,
    r: 95.5,
    fill: "#ff6584"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1035.02856,793.52344h-870s176.64-67.87,436.81-67.1c1.46,0,2.92.01,4.38.02q7.785.045,15.66.17,6.16508.105,12.38.26c1.79.04,3.58.09,5.38.14.72.02,1.43.04,2.14.06,1.65.05,3.31.1,4.98.16,3.13.1,6.27.22,9.42.34q4.13992.165,8.32.36c1.06.04,2.14.09,3.21.15q7.575.345,15.21.8c1.18.07,2.36.14,3.55.21,1.63.09,3.27.2,4.9.3q3.24.21,6.48.43c2.81.19,5.61.39,8.42.6q8.82.645,17.74,1.42c4.42.37,8.85.78,13.3,1.2q2.83494.27007,5.69.56,4.365.42,8.75.89c1.86.2,3.73.4,5.59.6,2.25.24,4.49.49,6.74.75,2.24.26,4.5.52,6.75.79q3.39.405,6.78.82c2.27.28,4.53.56,6.8.86,2.24.28,4.48.58,6.73.88q14.37,1.905,28.95,4.15c1.86.28,3.74.57,5.61.87q2.895.45,5.81.93,4.05.645,8.13,1.34c2.33.39,4.66.78,7,1.19,2.11.36005,4.24.73,6.36,1.11005q.33.06.66.12c2.34.41,4.69.84,7.03,1.27,2.35.43,4.71.87,7.06,1.31q3.54006.66,7.08,1.35c2.37.46,4.73.92,7.1,1.39,1.85.37,3.69.74,5.54,1.11.92.19,1.84.37,2.76.56q2.97.615,5.96,1.24,3.57.75,7.15,1.51c.27.06.53.12.8.17q5.55,1.2,11.11,2.44c.5.11,1.01.23,1.52.34q2.91.645,5.82,1.32c1.94.44995,3.88.89,5.83,1.35a2.0484,2.0484,0,0,1,.24.05c2.75.64,5.49,1.29,8.25,1.96q2.055.48,4.11.99c1.88.45,3.75.91,5.63,1.38,1.23.31,2.46.62,3.7.93.91.21,1.82.44,2.73.68q2.88.705,5.77,1.46,2.685.68994,5.37,1.38995a.83417.83417,0,0,1,.15.04c.43.11.85.22,1.28.33,1.31.34,2.62.69,3.94,1.04,1.35.36,2.71.72,4.07,1.09,1.19.32,2.39.64,3.58.97a.29566.29566,0,0,1,.1.02c.17.04.34.09.51.14,1.38.37,2.76.74,4.14,1.13,1.38.38,2.76.76,4.15,1.15.14.03.28.07.42.11q1.60493.43506,3.21.9s0-.01.01,0c.61.16,1.22.34,1.83.51q2.445.68994,4.89,1.38995c1.05.3,2.11.6,3.16.91,2.93.85,5.87,1.7,8.81,2.57s5.89,1.75,8.83,2.64c1.77.53,3.53,1.07,5.3,1.62q2.49.75,4.98,1.53C1030.05859,791.96344,1032.54858,792.7334,1035.02856,793.52344Z",
    transform: "translate(-164.66968 -105.52344)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1034.72681,794.47656C788.49438,716.5293,565.218,720.68164,421.27222,737.8916,265.325,756.53613,166.36841,794.08008,165.38745,794.457l-.71777-1.86719c.98388-.37793,100.17334-38.01074,256.36523-56.68457a1486.92048,1486.92048,0,0,1,276.89014-7.083,1444.32481,1444.32481,0,0,1,337.40527,63.748Z",
    transform: "translate(-164.66968 -105.52344)",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 706.85889,
    cy: 199.45055,
    r: 163.5,
    fill: "#6c63ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M993.15005,195.76883A163.51275,163.51275,0,0,1,720.71071,368.81244,163.51409,163.51409,0,1,0,993.15005,195.76883Z",
    transform: "translate(-164.66968 -105.52344)",
    opacity: 0.2
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "707.308 199.451 707.757 199.451 715.842 663 698.774 663 707.308 199.451",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 882.30878,
    y: 545.73223,
    width: 8.08516,
    height: 30.54396,
    transform: "translate(805.17582 -590.1641) rotate(62.23413)",
    fill: "#3f3d56"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "422.456 287.501 471.331 298.686 491.981 259.738 450.189 243.422 422.456 287.501",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M613.09257,602.687s-15.7109,36.00414-15.7109,46.47807c0,0,6.2189,28.476,4.255,36.33145l-6.87352,14.729-14.40166-5.89158-3.92772-39.27724.65462-62.84359Z",
    transform: "translate(-164.66968 -105.52344)",
    fill: "#ffb9b9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M621.93,387.31683s1.30924,21.60248-1.30925,28.14869,9.81931,18.984,9.81931,18.984l19.63862-25.53021s-13.09241-13.09241-9.81931-27.49406Z",
    transform: "translate(-164.66968 -105.52344)",
    fill: "#ffb9b9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M583.962,439.03187v34.69489l-2.9458,63.1709s-18.984,35.34951-.65462,32.731,12.11049-33.713,12.11049-33.713l6.21889-61.86165-.32731-37.64069Z",
    transform: "translate(-164.66968 -105.52344)",
    fill: "#ffb9b9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M576.76112,689.75158,604.90981,678.623l3.2731,55.64276s5.89159,17.02013,3.92773,23.56634c0,0,1.30924,11.12855-1.96387,11.78317s-12.43779,1.96387-13.09241,1.30924-.65462-2.61848-.65462-2.61848-6.54621,4.58235-7.20083,9.81931c0,0-27.49407,8.51007-28.14869.65462s13.747-14.40165,13.747-14.40165l11.12855-17.02014Z",
    transform: "translate(-164.66968 -105.52344)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M671.68112,602.687s-15.7109,36.00414-15.7109,46.47807c0,0,6.2189,28.476,4.255,36.33145l-6.87351,14.729-14.40166-5.89158-3.92772-39.27724.65462-62.84359Z",
    transform: "translate(-164.66968 -105.52344)",
    fill: "#ffb9b9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M636.3316,689.75158,664.48029,678.623l3.2731,55.64276s5.89159,17.02013,3.92773,23.56634c0,0,1.30924,11.12855-1.96387,11.78317s-12.43779,1.96387-13.09241,1.30924-.65462-2.61848-.65462-2.61848-6.54621,4.58235-7.20083,9.81931c0,0-27.49406,8.51007-28.14869.65462s13.747-14.40165,13.747-14.40165l11.12855-17.02014Z",
    transform: "translate(-164.66968 -105.52344)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 463.80647,
    cy: 266.73712,
    r: 20.94786,
    fill: "#ffb9b9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M631.09464,414.15628l16.25581-8.44172,7.31053,5.82324s17.67476-.65462,24.221,7.20082S689.02856,446.56,689.02856,446.56s-21.60248-4.58234-18.984,13.747l-3.92773-10.47393-3.60041,8.83738-43.85959,15.05627-19.63862-33.38565s-13.09241-3.92773-17.67476,5.237c0,0,.98194-33.05834,13.747-34.04027,8.58483-.66037,15.05627-.65462,15.05627-.65462l7.20083-1.30925,4.61127-1.63655Z",
    transform: "translate(-164.66968 -105.52344)",
    fill: "#6c63ff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M667,412s-10.01434,27.98029,1.58842,40.59849L658.916,485.83724S693.2836,588.94,683.46429,603.34165c0,0-36.65876,18.32938-109.97627-6.5462L603.27326,481.2549l-4.255-48.76924,5.89159-22.91173,13.09241-1.30924s-7.85545,29.45793,6.54621,34.04028S653,409,653,409Z",
    transform: "translate(-164.66968 -105.52344)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M667.42608,439.03187v34.69489l-2.94579,63.1709s-18.984,35.34951-.65462,32.731,12.11048-33.713,12.11048-33.713l4.58235-62.189,1.30924-37.31338Z",
    transform: "translate(-164.66968 -105.52344)",
    fill: "#ffb9b9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M689.02856,446.56s-2.327-33.6185-21.784-33.50208v38.87822S681.82774,443.2869,689.02856,446.56Z",
    transform: "translate(-164.66968 -105.52344)",
    fill: "#6c63ff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M616.64874,342.94043s-10.827,2.03656-13.33084,15.53985a24.78991,24.78991,0,0,0-.212,6.89493c.25,2.59923-.11264,8.08912-5.75648,14.55341a141.51216,141.51216,0,0,0-10.27621,13.19744h0l11.31328,3.01174,5.05475-18.744a95.88677,95.88677,0,0,1,11.20451-25.75249l.10392-.16674s3.75752,10.04,13.82869,11.41637l-3.10528-4.08841s11.77326,6.80583,18.44347,8.88488a4.38253,4.38253,0,0,1,1.41421,7.6208q-.071.05581-.14455.11171c-4.90609,3.72634-14.9149,12.61776-10.96075,21.219s-.657,10.16948-.657,10.16948l8.50294-3.23477,3.89178-1.66655-.39325,2.87748,18.99854.398s5.1339-.03118-3.98533-13.73515c0,0-2.20039-5.13845-.394-9.06405a20.85263,20.85263,0,0,0,2.10583-9.55488C661.72064,359.01229,655.90044,330.9046,616.64874,342.94043Z",
    transform: "translate(-164.66968 -105.52344)",
    fill: "#2f2e41"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 629.84215,
    cy: 369.99768,
    rx: 6.54621,
    ry: 5.89159,
    transform: "translate(13.29776 838.41558) rotate(-82.21788)",
    fill: "#2f2e41"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 614.92454,
    cy: 367.95896,
    rx: 6.54621,
    ry: 5.89159,
    transform: "translate(2.42003 821.8727) rotate(-82.21788)",
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 635.10638,
    y: 368.64755,
    width: 13.35208,
    height: 1.99985,
    transform: "translate(-186.26215 -65.2051) rotate(-3.53879)",
    fill: "#2f2e41"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 621.05921,
    y: 365.66044,
    width: 2,
    height: 6.54687,
    transform: "matrix(0.13541, -0.99079, 0.99079, 0.13541, 7.62269, 829.78457)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M481.18144,772.44738s.69056-14.46983,14.84712-12.78791",
    transform: "translate(-164.66968 -105.52344)",
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 312.51176,
    cy: 646.06885,
    r: 7.08526,
    fill: "#6c63ff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 311.35889,
    y: 658,
    width: 2,
    height: 14,
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M739.18144,775.44738s.69056-14.46983,14.84712-12.78791",
    transform: "translate(-164.66968 -105.52344)",
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 570.51176,
    cy: 649.06885,
    r: 7.08526,
    fill: "#6c63ff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 569.35889,
    y: 661,
    width: 2,
    height: 14,
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M314.18144,750.44738s.69056-14.46983,14.84712-12.78791",
    transform: "translate(-164.66968 -105.52344)",
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.51176,
    cy: 624.06885,
    r: 7.08526,
    fill: "#6c63ff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 144.35889,
    y: 636,
    width: 2,
    height: 14,
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M423.18144,731.44738s.69056-14.46983,14.84712-12.78791",
    transform: "translate(-164.66968 -105.52344)",
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 254.51176,
    cy: 605.06885,
    r: 7.08526,
    fill: "#6c63ff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 253.35889,
    y: 617,
    width: 2,
    height: 14,
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M696.18144,758.44738s.69056-14.46983,14.84712-12.78791",
    transform: "translate(-164.66968 -105.52344)",
    fill: "#3f3d56"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.51176,
    cy: 632.06885,
    r: 7.08526,
    fill: "#6c63ff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 526.35889,
    y: 644,
    width: 2,
    height: 14,
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M497.82288,144.98932l9.20568-7.36279c-7.15148-.789-10.0899,3.11126-11.29248,6.19836-5.587-2.32-11.66919.72046-11.66919.72046l18.41889,6.68671A13.938,13.938,0,0,0,497.82288,144.98932Z",
    transform: "translate(-164.66968 -105.52344)",
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M637.82288,219.98932l9.20568-7.36279c-7.15148-.789-10.0899,3.11126-11.29248,6.19836-5.587-2.32-11.66919.72046-11.66919.72046l18.41889,6.68671A13.938,13.938,0,0,0,637.82288,219.98932Z",
    transform: "translate(-164.66968 -105.52344)",
    fill: "#3f3d56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M486.82288,283.98932l9.20568-7.36279c-7.15148-.789-10.0899,3.11126-11.29248,6.19836-5.587-2.32-11.66919.72046-11.66919.72046l18.41889,6.68671A13.938,13.938,0,0,0,486.82288,283.98932Z",
    transform: "translate(-164.66968 -105.52344)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.f00bafad691a889701f7e2f9bf0c3932.svg";
export { ForwardRef as ReactComponent };